import { render, staticRenderFns } from "./ColumnSelector.vue?vue&type=template&id=45b42068&scoped=true&"
import script from "./ColumnSelector.vue?vue&type=script&lang=js&"
export * from "./ColumnSelector.vue?vue&type=script&lang=js&"
import style0 from "./ColumnSelector.vue?vue&type=style&index=0&id=45b42068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b42068",
  null
  
)

export default component.exports